import { IonCol, IonGrid, IonProgressBar, IonRow, IonText } from '@ionic/react';
import { ReactElement, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import FullscreenModal from '@components/FullscreenModal';
import styles from '@components/TrackerModal.module.css';
import { Opener } from '@hooks/useOpener';

type Props = {
  backAllowed: boolean;
  children: ReactElement;
  dataCy?: string;
  handleBack: () => void;
  handleUpdate?: () => void;
  headerKey: string;
  hideControls?: boolean;
  hideCurrentSection?: boolean;
  hideImage?: boolean;
  hideNext?: boolean;
  name: string;
  nextAllowed?: boolean;
  opener: Opener;
  questionIndex: number | null;
  sectionCount?: number;
  sectionKey?: string;
};

const TrackerModal = ({
  children,
  dataCy,
  headerKey,
  hideControls = false,
  hideCurrentSection = false,
  hideImage = false,
  name,
  opener,
  questionIndex,
  sectionCount,
  sectionKey
}: Props) => {
  const intl = useIntl();

  const progress = useMemo(() => {
    if (questionIndex !== null && sectionCount !== undefined) {
      return (questionIndex + 1) / sectionCount;
    }
  }, [questionIndex, sectionCount]);

  return (
    <FullscreenModal
      dataCy={dataCy}
      hideImage={hideImage}
      name={name}
      opener={opener}
      title={intl.formatMessage({ id: headerKey })}
    >
      {() => (
        <IonGrid className={styles.contentGrid} fixed>
          <IonRow>
            <IonCol>
              {!hideCurrentSection && !hideControls && (
                <div>
                  <div className={styles.currentSection}>
                    <IonText>
                      <FormattedMessage
                        id={sectionKey ?? 'pages.client.medications.sections.position'}
                        values={{ count: questionIndex === null ? 0 : questionIndex + 1, total: sectionCount }}
                      />
                    </IonText>
                  </div>
                  <IonProgressBar className={styles.progressBar} value={progress} />
                </div>
              )}
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <div className={styles.content}>{children}</div>
            </IonCol>
          </IonRow>
        </IonGrid>
      )}
    </FullscreenModal>
  );
};

export default TrackerModal;
